import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule,APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule,NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { ToastrWrapperService } from './_services/toastr-wrapper.service';
import { ToastrService } from 'ngx-toastr';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CardComponent } from './components/card/card.component';
import { LatestOffersComponent } from './pages/offers/latest-offers/latest-offers.component';
import { AddLatestOfferComponent } from './pages/offers/add-latest-offer/add-latest-offer.component';
import { TokenInterceptorService } from './_services/token-interceptor.service';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { LatestServicesListComponent } from './pages/services/latest-services-list/latest-services-list.component';
import { AddLatestServiceComponent } from './pages/services/add-latest-service/add-latest-service.component';
import { TestsListComponent } from './pages/tests/tests-list/tests-list.component';
import { AddTestComponent } from './pages/tests/add-test/add-test.component';
import { ShimmerComponent } from './components/shimmer/shimmer.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { CountriesListComponent } from './pages/geo-info/countries/countries-list/countries-list.component';
import { AddCountryComponent } from './pages/geo-info/countries/add-country/add-country.component';
import { AddCityComponent } from './pages/geo-info/cities/add-city/add-city.component';
import { CitiesListComponent } from './pages/geo-info/cities/cities-list/cities-list.component';
import { AreasListComponent } from './pages/geo-info/areas/areas-list/areas-list.component';
import { AddAreaComponent } from './pages/geo-info/areas/add-area/add-area.component';
import { AddCenterComponent } from './pages/centers/add-center/add-center.component';
import { CentersListComponent } from './pages/centers/centers-list/centers-list.component';
import { DoctorsLisitingComponent } from './pages/doctors/doctors-lisiting/doctors-lisiting.component';
import { AddDoctorComponent } from './pages/doctors/add-doctor/add-doctor.component';
import { SpecialtiesComponent } from './pages/Specialties/specialties/specialties.component';

import { AllAppointmentsComponent } from './pages/appointments/all-appointments/all-appointments.component';
import { LiveAppointmentsComponent } from './pages/appointments/live-appointments/live-appointments.component';
import { AppointmentDetailsComponent } from './pages/appointments/components/appointment-details/appointment-details.component';
import { SearchSpecialtyFilterPipe } from './pipe/search-speciality.pipe';
import { PaymentMethodsListComponent } from './pages/payment/payment-methods-list/payment-methods-list.component';
import { AddPaymentMethodComponent } from './pages/payment/add-payment-method/add-payment-method.component';
import { CouponsListComponent } from './pages/coupons/coupons-list/coupons-list.component';
import { AddCouponComponent } from './pages/coupons/add-coupon/add-coupon.component';
import { FaqListComponent } from './pages/FAQ/faq-list/faq-list.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AddSpecialityComponent } from './pages/Specialties/add-speciality/add-speciality.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FeaturedDoctorsListComponent } from './pages/doctors/featured-doctors/featured-doctors-list/featured-doctors-list.component';
import { UpdateFeaturedDoctorComponent } from './pages/doctors/featured-doctors/update-featured-doctor/update-featured-doctor.component';
import { TestRequestsListComponent } from './pages/test-requests/test-requests-list/test-requests-list.component';
import { UploadTestResultComponent } from './pages/test-requests/upload-test-result/upload-test-result.component';
import { BranchesPerLabListComponent } from './pages/branches/branches-per-lab-list/branches-per-lab-list.component';
import { AddBranchComponent } from './pages/branches/add-branch/add-branch.component';
import { CetnerTestComponent } from './pages/centers/cetner-test/cetner-test.component';
import { EmergencyPatientsComponent } from './pages/patients/emergency-patients/emergency-patients.component';
import { AddFaqComponent } from './pages/FAQ/add-faq/add-faq.component';
import { BiggerCardComponent } from './components/bigger-card/bigger-card.component';
import { HomeVisitFeesComponent } from './pages/centers/home-visit-fees/home-visit-fees.component';
import { HomeVisitFeesListComponent } from './pages/centers/home-visit-fees-list/home-visit-fees-list.component';
import { PushNotificationsComponent } from './pages/push-notifications/push-notifications.component';
import { PatientsListComponent } from './pages/patients/patients-list/patients-list.component';
import { PatientDetailsComponent } from './pages/patients/patient-details/patient-details.component';
import { SharedModule } from './shared/shared.module';
import { PatientSubscriptionsComponent } from './pages/patients/patient-subscriptions/patient-subscriptions.component';
import { NewLoginComponent } from './pages/new-login/new-login.component';
import { RequestPickUpComponent } from './pages/patients/request-pick-up/request-pick-up.component';
import { ViewMedicationRequestsComponent } from './pages/patients/view-medication-requests/view-medication-requests.component';
import { ApointmentSortingDirective } from './_directives/appointments/apointment-sorting.directive';
import { ReportsComponent } from './pages/reports/reports.component';
import { ChartComponent } from './pages/reports/charts/chart/chart.component';
import { CouponDetailsComponent } from './pages/coupons/coupon-details/coupon-details.component';
import { PageHeaderBreadcrumbComponent } from './components/page-header-breadcrumb/page-header-breadcrumb.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { PushNotificationModalComponent } from './pages/Specialties/components/push-notification-modal/push-notification-modal.component';
import { ReportModalComponent } from './pages/Specialties/components/report-modal/report-modal.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SpecialityReportComponent } from './pages/Specialties/components/speciality-report/speciality-report.component';
import { AddProplemModalComponent } from './pages/appointments/components/add-proplem-modal/add-proplem-modal.component';
import { RefundModalComponent } from './pages/appointments/components/refund-modal/refund-modal.component';
import { ReactiveModalComponent } from './pages/appointments/components/reactive-modal/reactive-modal.component';
import { CloseProblemModalComponent } from './pages/appointments/components/close-problem-modal/close-problem-modal.component';
import { RequestHomeDeliveryComponent } from './pages/patients/request-home-delivery/request-home-delivery.component';
import { AddNewAddressComponent } from './pages/patients/add-new-address/add-new-address.component';
import { AddAppointmentCouponComponent } from './pages/coupons/add-appointment-coupon/add-appointment-coupon.component';
import { AddTestCouponComponent } from './pages/coupons/add-test-coupon/add-test-coupon.component';
import { CouponDomainModalComponent } from './pages/coupons/coupon-domain-modal/coupon-domain-modal.component';
import { TestCouponDetailsComponent } from './pages/coupons/test-coupon-details/test-coupon-details.component';
import { AppointmentCouponDetailsComponent } from './pages/coupons/appointment-coupon-details/appointment-coupon-details.component';
import { PrescriptionFulfillmentRequestsComponent } from './pages/prescription-fulfillment/prescription-fulfillment-requests/prescription-fulfillment-requests.component';
import { PrescriptionRequestDetailsComponent } from './pages/prescription-fulfillment/prescription-request-details/prescription-request-details.component';
import { ImageModalComponent } from './pages/prescription-fulfillment/image-modal/image-modal.component';
import { MedicalTestsComponent } from './pages/patients/medical-tests/medical-tests.component';
import { NewTestRequestComponent } from './pages/patients/new-test-request/new-test-request.component';
import { SuccessfullRequestModalComponent } from './pages/patients/successfull-request-modal/successfull-request-modal.component';
import { TestRequestDetailsComponent } from './pages/patients/test-request-details/test-request-details.component';
import { UploadTestResultModalComponent } from './pages/patients/upload-test-result-modal/upload-test-result-modal.component';
import { MedicationRequestStatusModalComponent } from './pages/prescription-fulfillment/medication-request-status-modal/medication-request-status-modal.component';
import { LabTestsStatusModalComponent } from './pages/prescription-fulfillment/lab-tests-status-modal/lab-tests-status-modal.component';
import { UploadPrescriptionResultModalComponent } from './pages/prescription-fulfillment/upload-prescription-result-modal/upload-prescription-result-modal.component';
import { DatePipe } from '@angular/common';
import { LcaPatientsComponent } from './pages/lca-patients/lca-patients.component';
import { PatientEmrComponent } from './pages/patients/patient-emr/patient-emr.component';
import { EmrMedicationsComponent } from './pages/patients/emr-medications/emr-medications.component';
import { HospitalProceduresComponent } from './pages/patients/hospital-procedures/hospital-procedures.component';

import { EnrollToAnotherProgramComponent } from './pages/patients/enroll-to-another-program/enroll-to-another-program.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EmrPrescriptionDetailsComponent } from './pages/patients/emr-prescription-details/emr-prescription-details.component';
import { GetChannelNamePipe } from './pipe/get-channel-name.pipe';
import { UploadMultipleFilesModalComponent } from './components/upload-multiple-files-modal/upload-multiple-files-modal.component';
import { UploadMultipleFilesWithContentModalComponent } from './components/upload-multiple-files-with-content-modal/upload-multiple-files-with-content-modal.component';
import { DotsMenuComponent } from './components/dots-menu/dots-menu.component';
import { UploadingToolComponent } from './pages/uploading-tool/uploading-tool.component';
import { GetTestPrescriptionNamePipe } from './pipe/get-test-prescription-name.pipe';
import { EmrHospitalprocedureDetailsComponent } from './pages/patients/emr-hospitalprocedure-details/emr-hospitalprocedure-details.component';
import { ApprovalsComponent } from './pages/patients/approvals/approvals.component';
import { VitalsDataComponent } from './pages/patients/vitals-data/vitals-data.component';
import { ViewEditSubscriptionComponent } from './pages/patients/view-edit-subscription/view-edit-subscription.component';
import { ViewAttachmentComponent } from './pages/patients/view-attachment/view-attachment.component';
import { FlagSubscriptionModalComponent } from './pages/patients/flag-subscription-modal/flag-subscription-modal.component';
import { ViewFlaggingTrackingComponent } from './pages/patients/view-flagging-tracking/view-flagging-tracking.component';
import { SubscriptionHistoryModalComponent } from './pages/patients/subscription-history-modal/subscription-history-modal.component';
import { RowspanDirective } from './_directives/rowspan.directive';
import { EmergencyCardComponent } from './pages/emergency-card/emergency-card.component';
import { EmergencyManagementComponent } from './pages/emergency-management/emergency-management.component';
import { PspModule } from './pages/psp/psp.module';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    CardComponent,
    LatestOffersComponent,
    AddLatestOfferComponent,
    FooterComponent,
    SidebarComponent,
    NavbarComponent,
    AdminLayoutComponent,
    LatestServicesListComponent,
    AddLatestServiceComponent,
    TestsListComponent,
    AddTestComponent,
    ShimmerComponent,
    CountriesListComponent,
    AddCountryComponent,
    AddCityComponent,
    CitiesListComponent,
    AreasListComponent,
    AddAreaComponent,
    AddCenterComponent,
    CentersListComponent,
    DoctorsLisitingComponent,
    AddDoctorComponent,
    SpecialtiesComponent,
    AllAppointmentsComponent,
    LiveAppointmentsComponent,
    AppointmentDetailsComponent,
    SearchSpecialtyFilterPipe,
    PaymentMethodsListComponent,
    AddPaymentMethodComponent,
    CouponsListComponent,
    AddCouponComponent,
    FaqListComponent,
    AuthLayoutComponent,
    AddSpecialityComponent,
    FeaturedDoctorsListComponent,
    UpdateFeaturedDoctorComponent,
    TestRequestsListComponent,
    UploadTestResultComponent,
    BranchesPerLabListComponent,
    AddBranchComponent,
    CetnerTestComponent,
    EmergencyPatientsComponent,
    AddFaqComponent,
    BiggerCardComponent,
    HomeVisitFeesComponent,
    HomeVisitFeesListComponent,
    PushNotificationsComponent,
    PatientsListComponent,
    PatientDetailsComponent,
    PatientSubscriptionsComponent,
    NewLoginComponent,
    RequestPickUpComponent,
    ViewMedicationRequestsComponent,
    ApointmentSortingDirective,
    ReportsComponent,
    ChartComponent,
    CouponDetailsComponent,
    PageHeaderBreadcrumbComponent,
    DeleteModalComponent,
    PushNotificationModalComponent,
    ReportModalComponent,
    SpecialityReportComponent,
    AddProplemModalComponent,
    RefundModalComponent,
    ReactiveModalComponent,
    CloseProblemModalComponent,
    RequestHomeDeliveryComponent,
    AddNewAddressComponent,
    CouponDomainModalComponent,
    AddTestCouponComponent,
    AddAppointmentCouponComponent,
    TestCouponDetailsComponent,
    AppointmentCouponDetailsComponent,
    PrescriptionFulfillmentRequestsComponent,
    PrescriptionRequestDetailsComponent,
    ImageModalComponent,
    MedicalTestsComponent,
    NewTestRequestComponent,
    SuccessfullRequestModalComponent,
    TestRequestDetailsComponent,
    UploadTestResultModalComponent,
    MedicationRequestStatusModalComponent,
    LabTestsStatusModalComponent,
    UploadPrescriptionResultModalComponent,
    LcaPatientsComponent,
    PatientEmrComponent,
    HospitalProceduresComponent,
    EmrMedicationsComponent,
    EnrollToAnotherProgramComponent,
    EmrPrescriptionDetailsComponent,
    GetChannelNamePipe,
    UploadMultipleFilesModalComponent,
    UploadMultipleFilesWithContentModalComponent,
    DotsMenuComponent,
    UploadingToolComponent,
    GetTestPrescriptionNamePipe,
    EmrHospitalprocedureDetailsComponent,
    ApprovalsComponent,
    VitalsDataComponent,
    ViewEditSubscriptionComponent,
    ViewAttachmentComponent,
    FlagSubscriptionModalComponent,
    ViewFlaggingTrackingComponent,
    SubscriptionHistoryModalComponent,
    RowspanDirective,
    EmergencyCardComponent,
    EmergencyManagementComponent,
    CustomToastComponent,
    ToastContainerComponent
  ],
  imports: [
    AccordionModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    NgbModule,
    NgbModalModule,
    BrowserAnimationsModule,
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    TooltipModule.forRoot(),
    SharedModule,
    NgSelectModule,
    PspModule
  ],
  providers: [
    NgxImageCompressService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: ToastrService,
      useClass: ToastrWrapperService
    },
    DatePipe,
    GetChannelNamePipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        return () => {
          return Promise.resolve();
        };
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
